module.exports = __webpack_public_path__ + "static/telegram_PNG33-546a5475cf1445586f32e02520db74b2.png";